import { Tag, Copy } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { toast } from 'sonner';

const CodesTab = ({ discountCodes, codeQuantity, setCodeQuantity, codeAmount, setCodeAmount, generateCodes, generatingCodes }) => (
  <>
    <div className="flex items-center justify-between">
      <h3 className="text-sm font-semibold text-[#1D1D1B] dark:text-white flex items-center gap-2">
        <Tag className="h-4 w-4 text-[#80C753]" />
        Códigos de Descuento ({discountCodes.length})
      </h3>
    </div>

    {/* Generator */}
    <div className="p-4 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/30 space-y-3">
      <p className="text-sm font-medium text-[#1D1D1B] dark:text-white">Generar nuevos códigos</p>
      <div className="flex gap-3 items-end">
        <div className="flex-1">
          <label className="text-xs text-slate-500 mb-1 block">Cantidad</label>
          <Input data-testid="code-quantity-input" type="number" min="1" max="50" value={codeQuantity}
            onChange={(e) => setCodeQuantity(Number(e.target.value))} />
        </div>
        <div className="flex-1">
          <label className="text-xs text-slate-500 mb-1 block">Descuento (USD)</label>
          <Input data-testid="code-amount-input" type="number" min="1" value={codeAmount}
            onChange={(e) => setCodeAmount(Number(e.target.value))} />
        </div>
        <Button data-testid="generate-codes-btn" onClick={generateCodes} disabled={generatingCodes}
          className="bg-[#80C753] hover:bg-[#6ab043] text-white">
          {generatingCodes ? 'Generando...' : 'Generar'}
        </Button>
      </div>
    </div>

    {/* Codes List */}
    {discountCodes.length === 0 ? (
      <div className="text-center py-8 text-slate-400">
        <Tag className="h-12 w-12 mx-auto mb-3 opacity-50" />
        <p>No hay códigos generados</p>
      </div>
    ) : (
      <div className="space-y-2">
        {discountCodes.map((dc) => (
          <div key={dc.code} data-testid={`code-card-${dc.code}`}
            className={`p-3 rounded-lg border flex items-center justify-between ${
              dc.is_used
                ? 'border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/30 opacity-60'
                : 'border-[#80C753]/30 bg-[#80C753]/5'
            }`}>
            <div className="flex items-center gap-3">
              <code className="font-mono font-bold text-sm text-[#1D1D1B] dark:text-white">{dc.code}</code>
              <button onClick={() => { navigator.clipboard.writeText(dc.code); toast.success('Código copiado'); }}
                className="text-slate-400 hover:text-[#45A0EE]">
                <Copy className="h-3.5 w-3.5" />
              </button>
              <span className="text-sm font-medium text-[#80C753]">-${dc.discount_amount} USD</span>
            </div>
            <div className="text-right">
              {dc.is_used ? (
                <div>
                  <span className="text-xs px-2 py-0.5 bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-full">Usado</span>
                  <p className="text-xs text-slate-400 mt-1">{dc.used_by_name}</p>
                </div>
              ) : (
                <span className="text-xs px-2 py-0.5 bg-[#80C753]/20 text-[#80C753] rounded-full font-medium">Disponible</span>
              )}
            </div>
          </div>
        ))}
      </div>
    )}
  </>
);

export default CodesTab;
